import React from "react";
import PropTypes, { object } from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import {
	MDBRow,
	MDBCol,
	MDBCarousel,
	MDBCarouselInner,
	MDBCarouselItem,
	MDBView, MDBContainer,
} from "mdbreact";

import { GGgetMode } from "../../services/gglocalstorage";

import InnerLayout from "../../Layouts/InnerLayout/InnerLayout";
import BadgeSelected from "../../components/BadgeSelected/BadgeSelected";
import CardDisciplina from "../../components/CardDisciplina/CardDisciplina";
import CardDisciplinaPaliativo from "../../components/CardDisciplinaPaliativo/CardDisciplinaPaliativo";
import ButtonCTA from "../../components/ButtonCTA/ButtonCTA";
import SEO from "../../components/SEO/Seo";
import { ValidateHashPath } from "../../services/hashpathservice";
import SimuladorFinanceiro from "../../components/SimuladorFinanceiro/SimuladorFinanceiro";
import { ConvertModalidadeToDisplay } from "../../helpers/Formatters";

import Grade from "../../components/GradeCurricular/GradeCurricular";
import InformacoesCurso from "../../components/InformacoesCurso/InformacoesCurso";
import DiferenciaisCurso from "../../components/DiferenciaisCurso/DiferenciaisCurso";
import ImpulsionarCurriculo from "../../components/ImpulsionarCurriculo/ImpulsionarCurriculo";
import PorqueFeevale from "../../components/PorqueFeevale/PorqueFeevale";
import BotaoIngressoCurso from "../../components/BotaoIngressoCurso/BotaoIngressoCurso";
import TopoCurso from "../../components/TopoCurso/TopoCurso";
import InvestimentoCurso from "../../components/InvestimentoCurso/InvestimentoCurso";

import "../../components/Css/homeCurso.css";

export default function CursoHomePage({
	pageContext: {
		curso,
		listaGrupoCursos,
		coordenacoes,
		perfilDoEgresso,
		composicoesCurriculares,
	},
}) {
	CursoHomePage.propTypes = {
		pageContext: PropTypes.object.isRequired,
		curso: PropTypes.object.isRequired, // array de cursos
		cursosDaArea: PropTypes.object.isRequired, // array de cursos da area
		composicoesCurriculares: PropTypes.object.isRequired, // array de composicoes curriculares.
		listaGrupoCursos: PropTypes.object,
		coordenacoes: PropTypes.object,
		perfilDoEgresso: PropTypes.arrayOf(object),
	};


	let selectedIndex =
		typeof window !== "undefined"
			? ValidateHashPath(curso.Items.length, location.hash)
			: 0;
	let cursoSelecionado = curso.Items[selectedIndex];

	// Conteudo adicional
	let ConteudoAdicional =
		cursoSelecionado?.Informacoes?.ConteudoAdicional?.Value;
	// Variaveis para Perfil do egresso
	const categorias =
		perfilDoEgresso?.[0]?.[0]?.cursoPerfilDoEgressoCategoria ?? [];

	const habilidades =
		perfilDoEgresso?.[0]?.[0]?.cursoPerfilDoEgressoHabilidade ?? [];


	const flex = () => {
		if (cursoSelecionado.Informacoes?.Modalidade?.Value === "Hibrido") {
			return "Presencial";
		} else {
			return cursoSelecionado.Informacoes?.Modalidade?.Value;
		}
	};

	// Após definir cursoSelecionado:
	const associacao = cursoSelecionado.Informacoes?.Associacao?.Value;
	const modalidadeRaw = cursoSelecionado.Informacoes?.Modalidade?.Value;

	const cursosComModalidadeEADForcada = ["Marketing", "Logística"];

	const modalidade =
		cursosComModalidadeEADForcada.includes(associacao) &&
		modalidadeRaw === "Hibrido"
			? "EAD"
			: modalidadeRaw;

	//funcoes para grade currilar
	function isNumeric(char) {
		return !isNaN(char);
	}

	let identifier = "";

	function replaceIdentifierIfNotNumeric(text) {
		if (text && text.length > 0) {
			if (!isNumeric(text.charAt(0))) {
				return identifier;
			}
		}
		return text;
	}


	const cursosEspeciais = ["Letras - Português/Inglês", "História"];

	const cursoAtual = curso?.Items?.[0]?.Informacoes?.Associacao?.Value;

	const cursoEspecial = cursosEspeciais.includes(cursoAtual);

	const isMedicina = cursoAtual === "Medicina";

	const carouselMedicina = [
		{
			image:
				"https://www.feevale.br/Comum/midias/cf528953-e57b-4469-9881-608d5d2feb5c/1200x580/CIES-compressed.jpg",
			title: "Prédio CIES",
			text: "O Centro Integrado de Especialidades em Saúde (CIES) possui uma área física total de 3.246m², destinada ao atendimento de pacientes do SUS e à formação prática dos futuros profissionais da área da saúde.",
		},
		{
			image:
				"https://www.feevale.br/Comum/midias/7d55d248-9dc4-4c4b-8358-9d1eea6a4bd9/1200x580/CIES-recepcao-compressed.jpg",
			title: "Recepção do CIES",
			text: "O CIES é estruturado em três grandes áreas de funcionamento: assistencial, de ensino e de exames laboratoriais, proporcionando integração entre formação acadêmica e prática profissional.",
		},
		{
			image:
				"https://www.feevale.br/Comum/midias/19441348-e8c2-4570-b762-b49fb77fe195/1200x580/CIES-area-de-estudos-compressed.jpg",
			title: "Área de Estudos – CIES",
			text: "Espaços destinados aos estudos e à preparação acadêmica dos estudantes, localizados no prédio do CIES, salas 002, 004, 012D e 033, no Câmpus II.",
		},
		{
			image:
				"https://www.feevale.br/Comum/midias/4341525f-bc61-4686-958e-72b5e638ceda/1200x580/CIES-auditorio-compressed.jpg",
			title: "Auditório do CIES",
			text: "Auditório com capacidade para 108 pessoas, utilizado para aulas, eventos acadêmicos e atividades integradas do curso de Medicina, localizado no prédio do CIES, sala 104.",
		},
		{
			image:
				"https://www.feevale.br/Comum/midias/64094a67-1f4e-4245-aae8-38802c77e1ff/1200x580/Laborat%C3%B3rio-de-Simula%C3%A7%C3%A3o-e-Habilidades.jpg",
			title: "Laboratório de Simulação e Habilidades",
			text: "Laboratório equipado com robôs de alta fidelidade, capazes de simular respostas fisiológicas e farmacológicas reais, permitindo o treinamento seguro de procedimentos clínicos complexos.",
		},
		{
			image:
				"https://www.feevale.br/Comum/midias/98960eff-ae41-426c-aa3e-e8466316e41b/1200x580/Laborat%C3%B3rio%20de%20Anatomia-34.jpg",
			title: "Laboratório de Anatomia Humana Lauro Backes",
			text: "Ambiente com recursos audiovisuais e acervo de peças acrílicas e naturais abrangendo todos os sistemas do corpo humano, apoiando aulas teóricas e práticas do curso.",
		},
	];

	const CarouselMedicina = ({ items }) => (
		<MDBCarousel
			activeItem={1}
			length={items.length}
			showControls
			showIndicators
		>
			<MDBCarouselInner>
				{items.map((item, index) => (
					<MDBCarouselItem itemId={index + 1} key={index}>
						<MDBView>
							<img
								className="d-block w-100"
								src={item.image}
								alt={`Medicina ${index + 1}`}
							/>
						</MDBView>
						<div className="carousel-caption-box">
							<h5 className="carousel-med-title">{item.title}</h5>
							<p className="text-primary mb-0">{item.text}</p>
						</div>
					</MDBCarouselItem>
				))}
			</MDBCarouselInner>
		</MDBCarousel>
	);

	const instituto =
		cursoSelecionado.Informacoes?.Instituto?.Value?.toLowerCase() || "";

		const getClasseContainer = () => {
		if (isMedicina) return "homeConteinerDifeMed";

		if (instituto.includes("ics")) return "homeConteinerDifeICS";
		if (instituto.includes("ichs")) return "homeConteinerDifeICHS";
		if (instituto.includes("icct")) return "homeConteinerDifeICCT";

		return "homeConteinerDife"; // fallback
	};

	return (
		<InnerLayout curso={curso} listaGrupoCursos={listaGrupoCursos}>
			<SEO
				title={curso.Title}
				description={curso.Items[0].Argumentos.Proposito.Value}
			/>

			<TopoCurso
				curso={curso}
				cursoSelecionado={cursoSelecionado}
				selectedIndex={selectedIndex}
				cursoEspecial={cursoEspecial}
				isMedicina={isMedicina}
			/>

			
				<InformacoesCurso
					cursoSelecionado={cursoSelecionado}
					coordenador={coordenacoes?.[0]}
					isMedicina={isMedicina}
					ggMode={GGgetMode()}
					titulo="Informações do curso"
					subtitulo="Confira as principais informações sobre o curso."
				/>

			{isMedicina && (
				<div className={getClasseContainer()}>
					<Container className="my-0">
						<>
							<h4 className="text-white text-center mb-4 font-weight-bold">
								Espaços para Vivenciar Experiências Reais e Simuladas
							</h4>

							<CarouselMedicina items={carouselMedicina} />
						</>
					</Container>
				</div>
			)}

			<DiferenciaisCurso
				nomeCurso={associacao || cursoSelecionado.Title}
				categorias={categorias}
				habilidades={habilidades}
			/>

			<Container className={(GGgetMode() ? "bg-primary" : "") + ""}>
				{ConteudoAdicional && (
					<Row>
						<Col>
							<h4 className="text-primary">Mais sobre o curso</h4>
							<div
								className={GGgetMode() && "white-text"}
								dangerouslySetInnerHTML={{
									__html: ConteudoAdicional,
								}}
							/>
						</Col>
					</Row>
				)}
			</Container>
			{GGgetMode() && <hr className="bg-secondary mt-5" />}
			<ImpulsionarCurriculo cursoSelecionado={cursoSelecionado} />
			<Container
				fluid
				className={(GGgetMode() ? "bg-primary" : "") + " pt-3 "}
				style={{ backgroundColor: "#fff" }}
			>
				<InvestimentoCurso
					curso={curso}
					cursoSelecionado={cursoSelecionado}
					isMedicina={isMedicina}
					cursoEspecial={cursoEspecial}
				/>
					
					<MDBRow className="pb-3 mt-5 home-bolsas-fina">
						<Container>
						<MDBCol md={12} className="pr-md-5 mr-md-5 pb-5 pt-5">
							<MDBRow className="pb-4">
								<MDBCol className="text-center">
									<h3 className="font-weight-bold text-primary bg-white pb-2 pt-2 saira-title">BOLSAS E FINANCIAMENTOS</h3>
								</MDBCol>
							</MDBRow>
							<MDBRow className="imagensindex">
							
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://www.feevale.br/institucional/atendimento-financeiro-e-financiamento-estudantil/opcoes-de-financiamento"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/cdcc3fb4-63ef-400f-8987-252ddc8a639c/Banner-Banrisul.jpg"
											alt="Crédito universitário Banrisul. A gente descomplica pra você"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
								{/* <MDBCol col={6} xs={6} md={6} className="pb-2">
									<Link to={"/descontos"}>
										<img
											src="https://via.placeholder.com/487x228/FFFFFF/000000?text=BANNER%20DESCONTOS%20(487x228)"
											alt="Bolsas de até 50%* e 30%*! Clique e acesse"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</Link>
								</MDBCol> */}
								<MDBCol md="3" className="pb-2 " >
									<a
										href="https://www.pravaler.com.br/campanhas/lp-campeao/?ies_code=131&nome=FEEVALE&faculdade"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/2fdcb54e-5c7d-499a-afc9-bdb834ebffcd/MicrosoftTeams-image_(27).png"
											alt="Financiamento estudantil SEM JUROS é com Pravaler."
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://sicredipioneira.com.br/fale-conosco"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/fd7723a3-9906-4d39-86e0-285e8ccb5886/Banner-Sicredi.jpg"
											alt="Crédito universitário Sicredi"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
								<MDBCol md="3" className="pb-2 ">
									<a
										href="https://www.feevale.br/institucional/atendimento-financeiro-e-financiamento-estudantil/opcoes-de-financiamento/credies-feevale"
										target="_blank"
										rel="noreferrer"
									>
										<img
											src="https://www.feevale.br/s/conteudo/4566498c-a049-4b68-91ff-7217b59473e7/Banner-Credies.png"
											alt="CredIES Feevale sua graduação é agora! acesse credies.org"
											className="img-fluid col-12 p-0 rounded-lg"
										/>
									</a>
								</MDBCol>
							</MDBRow>
						</MDBCol>
						</Container>
					</MDBRow>
					<Container>
				<Row>
					<Col className="col-12 col-md-12 pt-3">
						<div id="curriculo">
							<Grade
								curso={associacao}
								formato={modalidade}
								tipo={cursoSelecionado.Informacoes.Tipo.Value}
							/>
						</div>
					</Col>
					<Col md="12">
						<div className="p-0 mt-4 mb-4">
								<BotaoIngressoCurso
									modalidade={
										cursoSelecionado?.Informacoes?.Modalidade?.Value
									}
									isMedicina={isMedicina}
									cursoEspecial={cursoEspecial}
								/>
							</div>
						</Col>
					</Row>
				</Container>
			</Container>
			{GGgetMode() && <hr className="bg-secondary" />}
			<PorqueFeevale/>
			{GGgetMode() && <hr className="bg-secondary" />}
		</InnerLayout>
	);
}
